const Wave1 = ({color="#111111"}) => {
	return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
		<path fill={color} fillOpacity="1" d="M0,160L48,144C96,128,192,96,288,106.7C384,117,480,171,576,165.3C672,160,768,96,864,96C960,96,1056,160,1152,154.7C1248,149,1344,75,1392,37.3L1440,0L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
	</svg>)
}

export default Wave1;